module.exports = __webpack_public_path__ + "static/img/me.7dc51002.png";